export default "__VITE_ASSET__CNaCczzR__"